import {call, put} from 'redux-saga/effects';
import { getCircuitVpnLogsSuccess, getCircuitVpnLogsError,
getCircuitVpnDetailsByEventsSuccess, getCircuitVpnDetailsByEventsError } from '../components/network-automation/circuit-vpn/redux/actions';

import { getCircuitVpnLogs, getCircuitVpnDetailsByEvents } from '../components/network-automation/circuit-vpn/CircuitVpnService';

function* loadCircuitVpnLogs ({requestParams}) {
    try {
        const response = yield call(getCircuitVpnLogs, requestParams);
        yield put(getCircuitVpnLogsSuccess(response));
    } catch (error) {
        yield put(getCircuitVpnLogsError(error.toString()));
    }
}

function* loadCircuitVpnDetailsByEvents ({id}) {
    try {
        const response = yield call(getCircuitVpnDetailsByEvents, id);
        yield put(getCircuitVpnDetailsByEventsSuccess(response));
    } catch (error) {
        yield put(getCircuitVpnDetailsByEventsError(error.toString()));
    }
}

export {loadCircuitVpnLogs, loadCircuitVpnDetailsByEvents};